import { useEffect, useState } from 'react'
import axios from 'axios'

import { getAllCompetitionsBySearchQuery } from '@/middlewares/services/competition.services'

const convertQuery = (old) => {
    return {
        searchTerm: old.searchTerm,
        type: old.eventType,
        ticketingPublished: old.openRegistration,
        divisionType: old.divisionType,
        month: typeof old.month === 'number' ? old.month + 1 : undefined,
        period: !old.period || old.period === 'all' ? undefined : old.period,
        country: old.country === 'All countries' ? undefined : old.country,
        categories: old.categories,
        pageNumber: old.pageNumber,
        pageSize: old.pageSize,
        view: old.view,
    }
}
export default function useSearchQuery(query) {
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState(false)
    // Tagged with the view that fetched them: map and list results are shaped
    // differently, and the view can flip from outside (logo link, back button).
    const [results, setResults] = useState({ view: undefined, data: [] })
    const [hasMore, setHasMore] = useState(false)

    useEffect(() => {
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()

        const fetchData = async () => {
            try {
                setIsLoading(true)
                setError(false)
                const response = await getAllCompetitionsBySearchQuery(convertQuery(query), source.token)

                setResults((previous) => ({
                    view: query.view,
                    data:
                        query.pageNumber === 1 || previous.view !== query.view
                            ? response.data
                            : [...previous.data, ...response.data].filter(
                                  (o, i, a) => a.findIndex((b) => b._id === o._id) === i,
                              ),
                }))
                setHasMore(response.data.length > 0)
                setIsLoading(false)
            } catch (event) {
                if (axios.isCancel(event)) return
                setError(true)
            }
        }
        fetchData()
        return () => source.cancel('Operation canceled by the user.')
    }, [query])

    // Never hand one view the other view's data, even for the frame before the refetch.
    const isFresh = results.view === query.view

    return { isLoading: isLoading || !isFresh, error, results: isFresh ? results.data : [], hasMore }
}
